import { Routes } from '@angular/router';
import { LivechatComponent } from "./livechat.component";

export const livechatRoutes: Routes = [
  {
    path: 'livechat',
    component: LivechatComponent
  }
];
